import Page_ThreeDeePageSkinComponent from '@wix/thunderbolt-elements/src/thunderbolt-core-components/Page/viewer/skinComps/ThreeDeePage/ThreeDeePageSkin.skin';


const Page_ThreeDeePageSkin = {
  component: Page_ThreeDeePageSkinComponent
};


export const components = {
  ['Page_ThreeDeePageSkin']: Page_ThreeDeePageSkin
};

